/**
 * NA-437: shared duration for both "Copy to another lesson" confirmation
 * paths — the toast's auto-dismiss (checkbox unchecked) and the copied
 * block's highlight-clear (checkbox checked) — so the two six-second
 * requirements in the ticket stay tied to one value rather than two
 * independently-tuned literals.
 */
export const COPY_CONFIRMATION_DURATION_MS = 6000;
